import './playing-card.scss';

import {React, useContext, useState} from 'react';

import Draggable from 'react-draggable';
import Files from 'react-files';
import PCList from './list';
import ProfileImage from './profile-image';
import {Resizable} from 're-resizable';
import { SettingsContext } from 'context/context';
import Weapons from 'components/layouts/card/weapons/weapons';

const PlayingCard = ({unit}) => {
  const [unitName, setUnitName] = useState('---');
  const { state } = useContext(SettingsContext);

  return (<div className="playing-card">
    <div className="playing-card-background"></div>
    <div className="playing-card-content">
      <div className="pc-profile">
      { state.personalize ?
          <span className="unit_name">
            <input type="text" name="personalized-name" value={unitName} onChange={e => setUnitName(e.target.value)} />
          </span> : null}
        <div className={`pc-name ${state.personalize ? 'with-custom' : null}`} dangerouslySetInnerHTML={{__html: unit.operativeType}}></div>
      </div>
      { state.displayImage ? (      <ProfileImage className="pc-image" />
) : (<hr />) }
      <table className="pc-stats">
        <tbody>
          <tr>
            <th>M</th>
            <th>APL</th>
            <th>GA</th>
            <th>DF</th>
            <th>SV</th>
          </tr>
          <tr>
            <td>{unit.stats.M}</td>
            <td>{unit.stats.APL}</td>
            <td>{unit.stats.GA}</td>
            <td>{unit.stats.DF}</td>
            <td>{unit.stats.SV}</td>
          </tr>
        </tbody>
      </table>
      <div className="pc-content">
        <Weapons weapons={unit.weapons} weaponsList={unit.weaponsList} className="pc-weapons" simplified="true" />

        { unit.abilities.length ? <PCList list={unit.abilities} label="Abilities" className="pc-abilities" /> : null}

        { unit.uniqueActions.length ? <PCList list={unit.uniqueActions} label="Unique Actions" className="pc-unique-actions" /> : null}

        <div className="pc-keywords">
          <strong>Keywords: </strong>
          { unit.keywords.primary ? <span dangerouslySetInnerHTML={{__html: unit.keywords.primary}}></span> : null }
          ,&nbsp;
          <span dangerouslySetInnerHTML={{__html: unit.keywords.secondary.map((category) => (category)).join(', ')}}></span>
        </div>
      </div>
    </div>
    <div className="pc-wounds"><strong>{unit.stats.W}</strong></div>
  </div>);
};

export default PlayingCard;
